import { useEffect, useState } from "react";
import { getMaterialStatusList } from "@/apis/supplier";

// ==================== 类型定义 ====================
export interface MaterialStatusOption {
  label: string;
  value: string;
}

interface MaterialStatusApiResponse {
  name: string;
  id: string;
}

// ==================== 自定义Hook ====================
/**
 * 获取物料状态选项的Hook
 * @param shouldFetch 是否应该获取数据（控制何时调用接口）
 * @returns {Object} 返回物料状态选项、加载状态和手动获取函数
 */
export const useMaterialStatusOptions = (shouldFetch: boolean = false) => {
  const [options, setOptions] = useState<MaterialStatusOption[]>([]);
  const [loading, setLoading] = useState(false);

  // 手动获取物料状态列表的函数
  const fetchMaterialStatus = async () => {
    try {
      setLoading(true);
      const response = await getMaterialStatusList();
      // 接口返回 { data: [{ name: "...", id: "..." }] }
      const data = response.data.data || [];

      if (Array.isArray(data) && data.length > 0) {
        // 将接口返回的 name 和 id 转换为 label 和 value
        const transformedOptions: MaterialStatusOption[] = data.map(
          (item: MaterialStatusApiResponse) => ({
            label: item.name,
            value: item.id,
          }),
        );
        setOptions(transformedOptions);
      } else {
        setOptions([]);
      }
    } catch (error) {
      console.error("获取物料状态列表失败:", error);
      // 失败时使用空数组
      setOptions([]);
    } finally {
      setLoading(false);
    }
  };

  // 仅在 shouldFetch 为 true 时调用接口
  useEffect(() => {
    if (shouldFetch) {
      fetchMaterialStatus();
    }
  }, [shouldFetch]);

  return { options, loading, fetchMaterialStatus };
};
